import React from 'react';
import styled from 'styled-components';

import InputSettingsField from './InputSettingsField';
import ButtonGroupSettings from './ButtonGroupSettings';

import ThemeIcons from '../../../theme/Icons';
import FormStylesOptions from '../../../constants/FormStylesOptions';

const StyledFieldWrapper = styled.div`
  margin: 0px 8px 12px 8px;
`;

const TitleSettings = ({ title, titleDisplay, onChange }) => {
  return (
    <>
      <StyledFieldWrapper>
        <InputSettingsField
          value={title}
          type="textarea"
          onChange={(i, value) => onChange({ title: value })}
        />
      </StyledFieldWrapper>
      <StyledFieldWrapper style={{ marginBottom: 0 }}>
        <ButtonGroupSettings
          types={[
            {
              type: FormStylesOptions.displayInline,
              icon: ThemeIcons.settings.display,
              active: titleDisplay === FormStylesOptions.displayInline || !titleDisplay,
            },
            {
              type: FormStylesOptions.displayNone,
              icon: ThemeIcons.settings.hide,
              active: titleDisplay === FormStylesOptions.displayNone,
            }
          ]}
          onChange={(value) => onChange({ titleDisplay: value })}
        />
      </StyledFieldWrapper>
    </>
  );
};

export default TitleSettings;
